import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';

export interface CandidateCounters {
  offers: Record<number, number>;
}

@Injectable({ providedIn: 'root' })
export class CandidateCountersHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public loadCounters(): Observable<CandidateCounters> {
    return this.httpApi.get(`/candidates/counters`);
  }
}
